import { useTranslation } from "react-i18next";
import { useGetFamilyCarLazyQuery } from "~/schemas/generated/graphql";
import { useEffect } from "react";
import { debounce, get } from "lodash";
import { language } from "~/libs/getData";

export const onScrollBottomFamilyCar = () => {
  const { t } = useTranslation();
  const isEn = language === "en";

  const [GetFamilyCarForSelectQuery, { data, loading, fetchMore }] =
    useGetFamilyCarLazyQuery({
      variables: {
        count: 25,
        page: 0,
      },
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true,
    });

  useEffect(() => {
    GetFamilyCarForSelectQuery();
  }, []);

  const familyCarForSelect = [
    ...get(data, "SRRGetter.getFamilyCar.items", []).map(({ id, name }) => {
      return {
        value: id,
        label: name,
      };
    }),
  ];

  const introspectionHandler = () => {
    if (familyCarForSelect.length < 25) {
      return;
    }
    const page = Math.ceil(familyCarForSelect.length / 25);
    fetchMore({
      variables: {
        page,
      },
      updateQuery: ({ SRRGetter }, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return { SRRGetter };
        }
        return {
          SRRGetter: {
            ...SRRGetter,
            getFamilyCar: {
              ...SRRGetter.getFamilyCar,
              items: [
                ...SRRGetter.getFamilyCar.items,
                ...get(fetchMoreResult, "SRRGetter.getFamilyCar.items", []),
              ],
            },
          },
        };
      },
    });
  };

  const searchFamilyCar = debounce((searchText: string) => {
    GetFamilyCarForSelectQuery({
      variables: {
        page: 0,
        name: searchText,
      },
    });
  });

  return {
    familyCarForSelect,
    introspectionHandler,
    searchFamilyCar,
    GetViolationTypesLoading: !!loading,
  };
};
